import type { InMemoryCache } from '@apollo/client';
import { useApolloClient, useQuery } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';

import type { Maybe } from '@xing-com/crate-common-graphql-types';

import { LOGGED_IN_CARDS_PER_PAGE } from '../../config';
import { XcpManagedCompaniesDocument } from '../../graphql/queries/managed-companies.gql-types';

const useManagedCompanies = ({ first = LOGGED_IN_CARDS_PER_PAGE } = {}) => {
  const client = useApolloClient();

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  (client.cache as InMemoryCache).policies.addTypePolicies({
    Viewer: {
      fields: {
        managedCompanies: relayStylePagination(),
      },
    },
  });
  const variables = {
    first,
  };
  const { fetchMore, error, ...rest } = useQuery(XcpManagedCompaniesDocument, {
    variables,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  const pagination = async (endCursor: Maybe<string>) => {
    await fetchMore({
      variables: {
        first,
        after: endCursor,
      },
    });
  };

  return {
    pagination,
    error,
    ...rest,
  };
};

export { useManagedCompanies };
